import { inject } from '@angular/core';
import { AES } from "crypto-js"
import { CommonLookupData } from '../../shared/commonHelper/common.service';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-common';
import { Router } from '@angular/router';

export const CanActivate = async() => {
    const _commonLookupData = inject(CommonLookupData);
    const _authService: MsalService = inject(MsalService);
    const _router: Router = inject(Router);

    _authService.initialize();

    //Regenerate token if expired
    _authService.handleRedirectObservable().subscribe({ 
        next: (result: AuthenticationResult) => {
          if (result != null) {
            localStorage.setItem("msal.idtoken", result.idToken);
          }
           if (_authService.instance.getAllAccounts().length > 0) {
            const account = _authService.instance.getAllAccounts()[0];
            if (account && account.idTokenClaims && account.idTokenClaims.exp) {
                var idTokenExpiryDatetime = new Date(account.idTokenClaims.exp * 1000);
                var currentDatetime = new Date();

                if (idTokenExpiryDatetime.getTime() < currentDatetime.getTime()) {
                    const renewIdTokenRequest = {
                        scopes: ["user.read"],
                        account: account,
                        forceRefresh: true
                    }
    
                    _authService.instance.acquireTokenSilent(renewIdTokenRequest).then(token => {
                        if (token) {
                            localStorage.setItem("msal.idtoken", token.idToken);
                        }
                    }).catch(error => {
                        _authService.loginRedirect();
                    });
                }
            }
           } else {
            localStorage.clear();
            _authService.loginRedirect();
           }
        },
        error: (error) => console.log(error)
     });
    
    if (_authService.instance.getAllAccounts().length > 0) {
        _commonLookupData.getAdminSiteUrls((result: any) => { 
            if(result && result.length>0)
            {
                result.forEach(domain => {
                    var ifr = document.getElementById("ifr_"+domain.recordId);
                    if(ifr == null)
                    {
                        var iframe = document.createElement('iframe');
                        iframe.src = domain.url;
                        iframe.id="ifr_"+domain.recordId
                        document.body.appendChild(iframe);
                        document.getElementById("ifr_"+domain.recordId).style.display = "none";
                    }
                    const element: HTMLIFrameElement = document.getElementById("ifr_"+domain.recordId) as HTMLIFrameElement;
                    var token= AES.encrypt(new Date().toString(), "SecretKey").toString();
                    element.contentWindow.postMessage(token,"*");
                });
            }
        });
        return true;
    } else {
        localStorage.clear();
        _authService.handleRedirectObservable().subscribe({ 
            next: (result: AuthenticationResult) => {
                if (result != null) {
                    localStorage.setItem("msal.idtoken", result.idToken);
                }
                if (_authService.instance.getAllAccounts().length > 0) {
                    _router.navigate(['/dashboard']);
                } else {
                    localStorage.clear();
                    _authService.loginRedirect();
                }
            },
            error: (error) => console.log(error)
         });
        return false;
    }
}
